import { LanguageService } from '../../../../core/services/language.service'
import { MapsConfig } from '../contract/map-config.contract'

export function googleMapsConfigFactory(apiKey: string): (ls: LanguageService) => MapsConfig {
  return (languageService: LanguageService): MapsConfig => {
    return {
      key: apiKey,
      ...(languageService ? { language: languageService.getCurrentLocale() } : {})
    }
  }
}
